module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Iniciacion RO.6e2f4e69.png";